import { render } from "./DynamicSection.vue?vue&type=template&id=9614dc36"
import script from "./DynamicSection.vue?vue&type=script&lang=js"
export * from "./DynamicSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__